export default {
  init() {

  },
  finalize() {

    // edit these vars
    var nice_url   = true;
    var pagination = false;
    var animation_speed = '0';
    var post_order = 'DESC';
    var random_posts = true;
    var featured_image = true;
    var acf = true;

    // default vars
    var page      = 0;
    var filter    = 0;
    var numberposts = 8;
    var total_item_count = 0;
    var exlude_ids = [];
    var seed = Math.floor(Math.random() * 1000) + 1;

    // loop the filter buttons and check if selected filter is set
    $('.lazy-load-filter').each(function() {
      // if finds selected index set the filter id
      if($(this).data('selected')) {
        filter = $(this).data('index');
      }
    })

    // load initail items
    getLazyItems();

    // assign buttons to clicks
    $('.lazy-load-more').click(() => getLazyItems());
    $('.lazy-load-filter').click((e) => setLazyFilter(e));
    $('.lazy-load-filter-mobile').change((e) => setLazyFilter(e, true));

    function setLazyFilter(e, mobile = false) {
      var target = $(e.target);

      if(mobile) {
        target = $(e.target).find(':selected');
      }

      // clear current items from div
      exlude_ids = [];

      $('.lazy-load-items').fadeOut(animation_speed, function() {

        // Animation complete.
        $('.lazy-load-items').empty();
        // reset page to 0
        page = 0;

        // set the filter id from the data index
        filter = target.data('index');

        // get the items with the new filter id
        getLazyItems()

        $('.lazy-load-filter').each(function() {
          $(this).removeClass('active');
        })

        target.addClass('active');

        $('.lazy-load-items').fadeIn( animation_speed);
        //set pretty slug url
        if(nice_url) {
          window.history.pushState('', '', target.data('slug'));
        }
      });
    }

    function getLazyItems() {
      console.log('lazy');
      // hide load more button to counter flickering
      $('.lazy-load-pagination').hide();

      // eslint-disable-next-line no-undef
      var ajax_url = ajax_object.ajax_url;

      // set initial post count
      total_item_count = 5;

      var tax_query = '';

      if(filter != 0) {
        tax_query = [{
          'taxonomy': 'news-categories',
          'field': 'slug',
          'terms': filter,
        }];
      }

      // do ajax(super joden) call to the server
      $.ajax({
        type: 'post',
        url: ajax_url,
        data : {
          action: 'lazyload', // action called in ajax.php
          featured_image: featured_image,
          acf: acf,
          args: { // args parameters passed to wp_query method
            'posts_per_page': numberposts,
            'post_type': 'news',
            'post_status':'publish',
            'paged': page + 1,
            'tax_query': tax_query,
            'order': post_order,
            'orderby': random_posts ? 'RAND(' + seed + ')' : 'ID',
          },
        },
      }).done(function(items) {

        //
        $('.lazy-load-pagination').show();

        // set items string to array
        var responseItems = JSON.parse(items);

        // set global total var
        total_item_count = responseItems.total_item_count;

        // check if items available
        if(responseItems.items.length > 0 ) {

          var item_html = '';

          // loop the items
          responseItems.items.map((element) => {

            if(random_posts) {
              if(exlude_ids.includes(element.ID) === false) {
                exlude_ids.push(element.ID);
              }
            }
            console.log(exlude_ids);
            // style the items and append them to the frontend div
            item_html += `<div class="w-full lg:w-6/12 mb-4 md:mb-0 bg-black px-8 md:even:mt-16 group relative overflow-hidden">
                            <div class="block">
                              <div class="h-48 md:h-48 lg:h-96 relative overflow-hidden">
                                ${element.featured_image}
                                <div class="absolute bottom-0 left-0 right-0 h-32 z-10 transition-bezier transition-600 bg-gradient-b-black"></div>
                              </div>
                              <div class="p-4 md:p-8 lg:p-16 w-full -mt-12 lg:-mt-32 z-10 relative">
                                <div class="mb-8">
                                  <div class="pt-2 px-2 pb-1 bg-white font-primary text-xs lg:text-base inline-block leading-none text-black uppercase">
                                    ${element.date}
                                  </div>
                                </div>
                                <h3 class="mb-4 mt-4 text-white text-base md:text-xl lg:text-3xl xl:text-4xl tracking-wide leading-tight">${element.post_title}</h3>
                                <p>${element.description}</p>
                                <a class="text-white group font-primary mt-4 flex items-center text-small lg:text-xl transition-bezier transition-300 hover:tracking-wider" href="${element.permalink}">
                                  <span class="w-4 h-01 bg-white inline-block mr-4 transition-bezier transition-300"></span>
                                  Bekijk bericht
                                </a>
                              </div>
                            </div>
                          </div>`;
          });

          $('.lazy-load-items').fadeIn(animation_speed, function() {});

          if(pagination) {
            $('.lazy-load-items').html(item_html);
          } else {
            $('.lazy-load-items').append(item_html);
          }

        } else {
          // no items available
          if(!pagination) {
            $('.lazy-load-items').append('<div class="end-lazyload text-center text-sm opacity-50 w-full">Alle items zijn ingeladen</div>');
          }
        }

      }).then(function(){
        renderPagination()
      });
    }

    function nextPage(){page = page + 1;}
    function prevPage(){page = page - 1;}
    function setPage(pageNumber){page = pageNumber;}

    function renderPagination() {
      var total_render_pages = Math.ceil(total_item_count / numberposts);

      var pagination_render = '';

      if(pagination) {

        for (var i = 0; i < total_render_pages; i++) {
          pagination_render += '<button class="lazy-load-set-page" data-page="'+i+'">'+(i + 1) +'</button>';
        }

      } else {
        if(total_render_pages >= 1 ) {
          pagination_render +='<div class="lazy-load-more text-center border-gray-100 border py-2 px-4 transition-300 transition-ease font-bold font-primary inline-block cursor-pointer hover:bg-white hover:text-black hover:border-white">Meer laden</div>';
        }
      }

      $('.lazy-load-pagination').html(pagination_render);
    }

    $('.lazy-load-pagination').on('click', '.lazy-load-more', function() {
        nextPage();
        getLazyItems();
    });

    $('.lazy-load-pagination').on('click', '.lazy-load-prev', function() {
        prevPage()
        getLazyItems();
    });

    $('.lazy-load-pagination').on('click', '.lazy-load-next', function() {
        nextPage();
        getLazyItems();
    });
    $('.lazy-load-pagination').on('click', '.lazy-load-set-page', function() {
        setPage($(this).data('page'));
        getLazyItems();

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/news.js